// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  archetypeId: __t.string(),
  weight: __t.u32(),
  patienceMultX100: __t.i32(),
  tipMultX100: __t.i32(),
  orderSizeBias: __t.i32(),
  wcUseChanceX100: __t.i32(),
};
